import React from 'react';
import { LiveTranscriptBar } from './LiveTranscriptBar';
import { NewInquiryBar } from './NewInquiryBar';

// Renders the fixed sub-header row beneath the TopBar.
// Each half owns its own `relative` context so each bar's expanded dropdown
// stays within its half-width column rather than overlapping the other side.
export const CombinedInfoBar: React.FC = () => {
  return (
    <div className="bg-white border-b border-gray-200 shadow-sm">
      <div className="flex min-w-0 divide-x divide-gray-200">
        <div className="flex-1 min-w-0 relative">
          <LiveTranscriptBar />
        </div>
        <div className="flex-1 min-w-0 relative">
          <NewInquiryBar />
        </div>
      </div>
    </div>
  );
};
